import { render, staticRenderFns } from "./XaiOverview.vue?vue&type=template&id=bbcf3c3a&scoped=true&"
import script from "./XaiOverview.vue?vue&type=script&lang=js&"
export * from "./XaiOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcf3c3a",
  null
  
)

export default component.exports